const STEPS = [
  { when: 'Before the meeting', title: 'Invite the bot', body: 'Add bot@calendarfeedback.com as a guest on any Google Calendar event. It accepts the invite and does nothing else.', img: '/img/step-invite.webp', alt: 'A paper envelope with an invitation card and a small blue token.' },
  { when: 'Fifteen minutes after', title: 'Everyone gets three buttons', body: 'Up to ten accepted attendees receive one email. Tap thumbs up, neutral or thumbs down, confirm, done. No account, no app.', img: '/img/step-vote.webp', alt: 'Three paper cards cut with a thumbs up, a flat line and a thumbs down.' },
  { when: 'Two hours after', title: 'The score lands', body: 'The organiser and everyone who voted see one 0 to 100 number. Never who voted, never what.', img: '/img/step-score.webp', alt: 'A paper card with a blue meter beside a small paper calendar.' },
]

export function Timeline() {
  return (
    <section className="wrap section" aria-labelledby="how-title">
      <h2 id="how-title">How it works</h2>
      <ol className="steps">
        {STEPS.map(s => (
          <li className="step" key={s.title}>
            <img src={s.img} alt={s.alt} width={700} height={700} loading="lazy" />
            <span className="label">{s.when}</span>
            <h3>{s.title}</h3>
            <p>{s.body}</p>
          </li>
        ))}
      </ol>
      <p className="note">
        Surveys go out only when at least three attendees accepted the invite, a score appears
        only after three votes, and links stay live for two hours. Meetings shorter than ten
        minutes and all-day events are skipped.
      </p>
    </section>
  )
}
